import React from "react";
import "./SecondaryButton.css";

export default function SecondaryButton({
  title,
  onClick,
  loading = false,
  disabled = false,
  type = "button",
  fullWidth = false,
  icon = null
}) {
  return (
    <button
      type={type}
      className={`secondary-button
                  ${loading ? "is-loading" : ""}
                  ${fullWidth ? "full-width" : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="spinner"></span>
      ) : (
        <>
          {icon && <span className="btn-icon">{icon}</span>}
          <span className="btn-title">{title}</span>
        </>
      )}
    </button>
  );
}
